import { useState, useEffect } from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LanguageProvider, useLanguage } from "./i18n";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import MainApp from "./components/MainApp";
import InstallAppBanner from "./components/InstallAppBanner";
import NotificationManager from "./components/NotificationManager";
import OrganizationPortal from "./components/OrganizationPortal";
import "@/App.css";

const AppContent = () => {
  const { user, loading } = useAuth();
  const { t } = useLanguage();

  // Check for special routes
  const path = window.location.pathname;
  
  // Portale Organizzazioni
  if (path === '/org' || path === '/org/') {
    return <OrganizationPortal />;
  }
  
  // Join via invite code
  if (path.startsWith('/join/')) {
    const inviteCode = path.split('/join/')[1];
    // Store invite code and redirect to login
    if (inviteCode) {
      localStorage.setItem('pending_invite_code', inviteCode.toUpperCase());
    }
    // Continue to normal login flow
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin mb-4"></div>
          <p className="text-slate-400">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  // Rendering condizionale: Login o MainApp
  return user ? <MainApp /> : <Login />;
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <InstallAppBanner />
          <AppContent />
          <NotificationManager />
          <Toaster 
            position="top-center" 
            richColors 
            theme="dark"
            toastOptions={{
              style: {
                background: '#0F172A',
                border: '1px solid rgba(6, 182, 212, 0.3)',
                color: '#f8fafc'
              }
            }}
          />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
